import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { FaLinkedin } from 'react-icons/fa';

import styles from './sustentabilidad.module.scss';
import modeloCirculo from '../../img/modelo_gestion_circulo.png';
import modeloCuadro1 from '../../img/modelo_gestion_cuadro1.png';
import modeloCuadro2 from '../../img/modelo_gestion_cuadro2.png';
import modeloCuadro3 from '../../img/modelo_gestion_cuadro3.png';

let cx = classNames.bind(styles);

const Sustentabilidad = () => {
	const { t } = useTranslation();

	return (
		<section id='sustentabilidad' className={cx({ sustentabilidad: true })}>
			<div className='container mx-auto flex flex-col items-center'>
				<div className='flex flex-col text-ccu-green lg:w-4/8 mb-12'>
					<h1 className='text-4xl lg:text-6xl font-bold leading-none'>SUSTENTABILIDAD </h1>
					<p className='text-ccu-dark text-2xl text-right font-bold leading-none'>
						en CCU
					</p>
				</div>
				<div className='flex flex-col lg:flex-row lg:mb-4'>
					<div className='flex flex-col w-full lg:w-4/12 h-auto justify-center items-center px-4 lg:m-0'>
						<Img src={modeloCirculo} className='w-full' />
					</div>
					<div className='flex flex-col lg:flex-row w-full lg:w-8/12 px-4 lg:pl-4 pt-16'>
						<div className='flex flex-col w-full lg:w-1/3 mb-8 lg:mb-1 lg:mr-3 shadow-xl lg:shadow-none'>
							<div className='flex flex-row items-center justify-between bg-ccu-red text-white py-2 px-4 rounded-t-lg'>
								<h1 className='w-4/5 uppercase leading-none font-bold'>
									PERSONAS QUE NOS MUEVEN
								</h1>
								<Img src={modeloCuadro1} className='w-10' />
							</div>
							<div className='text-ccu-dark p-2 text-sm'>
								<p className='py-3'>
									Vivimos en un mundo integrado donde nuestra acción impacta a
									las personas, y esa interacción nos inspira a buscar un mejor
									vivir para todos.
								</p>
								<ul className=''>
									<li>
										<span className='text-ccu-red'> > </span> Trabajadores
									</li>
									<li>
										<span className='text-ccu-red'> > </span> Clientes
									</li>
									<li>
										<span className='text-ccu-red'> > </span> Proveedores
									</li>
									<li>
										<span className='text-ccu-red'> > </span> Comunidades
									</li>
								</ul>
							</div>
						</div>
						<div className='flex flex-col w-full lg:w-1/3 mb-8 lg:mb-1 lg:mr-3 shadow-xl lg:shadow-none'>
							<div className='flex flex-row items-center justify-between bg-ccu-yellow text-white py-2 px-4 rounded-t-lg'>
								<h1 className='w-4/5 uppercase leading-none font-bold'>
									PLANETA POR EL QUE VELAMOS
								</h1>
								<Img src={modeloCuadro2} className='w-12 pt-1' />
							</div>
							<div className='text-ccu-dark p-2 text-sm'>
								<p className='py-3'>
									Nuestras operaciones buscan minimizar el impacto ambiental,
									promoviendo el cuidado del medio ambiente y con actitud por
									sobre el cumplimiento normativo. Este desafío lo plasmamos en
									nuestra Visión Medioambiental.
								</p>
								<ul className=''>
									<li>
										<span className='text-ccu-yellow'> > </span> Emisiones
									</li>
									<li>
										<span className='text-ccu-yellow'> > </span> Residuos
									</li>
									<li>
										<span className='text-ccu-yellow'> > </span> Agua
									</li>
								</ul>
							</div>
						</div>
						<div className='flex flex-col w-full lg:w-1/3 mb-8 lg:mb-1 lg:mr-3 shadow-xl lg:shadow-none'>
							<div className='flex flex-row items-center justify-between bg-ccu-blue text-white py-2 px-4 rounded-t-lg'>
								<h1 className='w-4/5 uppercase leading-none font-bold'>
									MARCAS QUE NOS INSPIRAN
								</h1>
								<Img src={modeloCuadro3} className='w-12  py-1' />
							</div>
							<div className='text-ccu-dark p-2 text-sm'>
								<p className='py-3'>
									Nuestro negocio se sustenta en marcas de valor, que entregan a nuestros consumidores experiencias para compartir un mejor vivir.
								</p>
								<ul className=''>
									<li>
										<span className='text-ccu-blue'> > </span> Innovación
									</li>
									<li>
										<span className='text-ccu-blue'> > </span> Consumo Responsable
									</li>
									<li>
										<span className='text-ccu-blue'> > </span> Nuestros Consumidores
									</li>

								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className={cx({ 'flex flex-col-reverse lg:flex-row w-full': true, video: true })}>
					<div className='hidden lg:flex flex-col w-auto bg-ccu-blue h-auto items-center justify-center'>
						<iframe
							width='560'
							height='300'
							src='https://www.youtube-nocookie.com/embed/ZuMBtaWj4Fc?showinfo=0&rel=0&autoplay=0&controls=0'
							frameborder='0'
							allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
							allowfullscreen
						></iframe>
					</div>
					<div className='lg:hidden flex flex-col w-auto bg-ccu-blue h-auto items-center mx-4 justify-center'>
						<iframe
							className='w-full h-auto'
							src='https://www.youtube-nocookie.com/embed/ZuMBtaWj4Fc?showinfo=0&rel=0&autoplay=0&controls=0'
							frameborder='0'
							allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
							allowfullscreen
						></iframe>
					</div>
					<div className='flex flex-col w-full lg:w-6/12 p-8'>
						<h1 className='font-bold text-ccu-green text-3xl font-Ubuntu-Bold'>
							¡Mirá nuestro video!
						</h1>
						<p className='text-ccu-dark text-xl font-Roboto-Regular'>
							Para CCU, la Suatentabilidad constituye uno de los tres pilares
							estratégicos de la compañía, junto con Rentabilidad y Crecimiento.
							En conjunto, componen la hoja de ruta para plasmar el Ser CCU y su
							propósito: “nos apasiona crear experiencias para compartir juntos
							un mejor vivir”.
						</p>
					</div>
				</div>
			</div>
			<div className='flex flex-col w-full items-center lg:items-end bg-ccu-dark-green text-white p-4 lg:pr-20'>
				<h1 className='font-bold text-3xl text-center'>
					<a
						href='https://www.linkedin.com/company/compa%C3%B1%C3%ADacervecer%C3%ADasunidas/'
						target='_blank'
						rel='noopener noreferrer'
					>
						Seguinos en nuestra Red de LinkedIn
						<FaLinkedin className='text-5xl inline p-1 pb-2' />
					</a>
				</h1>
			</div>
		</section>
	);
};

export default Sustentabilidad;
